import { lacUserService } from '../../services/LacUserService';

export function downloadLacUserPhoto(
  tenantName: string,
  userRef: string,
): Promise<Blob | null | undefined> {
  return lacUserService.downloadUserPhoto(tenantName, userRef);
}
